// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.ctn-info-page {
  margin-bottom: 30px;
}

.ctn-info {
  margin: 0 16.66%;
}
.ctn-info h1 {
  margin-top: 30px;
}
.ctn-info .alert {
  margin: -10px 0 30px;
}
.ctn-info h2 {
  font: 20px "Omnes-ATT-W02-Medium";
  padding: 30px 0 30px;
  margin: 0;
}
.ctn-info .valign-children-middle h2 {
  font-size: 16px;
}
.ctn-info .valign-children-middle h2, .ctn-info .valign-children-middle p {
  padding: 0 !important;
}
.ctn-info .lite {
  margin-top: 10px;
  background-color: #d2d2d2 !important;
  color: #d2d2d2;
}
.ctn-info .userInfoContainer {
  border-bottom: 1px solid #d2d2d2;
}
.ctn-info .deviceInfoContainer {
  border-top: 1px solid #d2d2d2;
}
.ctn-info p {
  margin-bottom: 0;
}
.ctn-info p:last-child {
  padding-bottom: 30px;
}
.ctn-info p span {
  font-weight: normal;
}
.ctn-info .nav-container {
  display: inline;
}
.ctn-info .ctn-nav-icons li, .ctn-info .ctn-nav-icons-oem li {
  display: inline-block;
  margin: 20px 0 20px;
  text-align: center;
  vertical-align: top;
  width: 24%;
}
.ctn-info .ctn-nav-icons li i, .ctn-info .ctn-nav-icons-oem li i {
  font-size: 50px;
}
.ctn-info .ctn-nav-icons img, .ctn-info .ctn-nav-icons-oem img {
  margin-bottom: 10px;
}
.ctn-info .lock-support-modal li {
  font-weight: normal;
  list-style-type: decimal;
}
.ctn-info .wipe-support-modal li {
  font-weight: normal;
  list-style-type: disc;
}
.ctn-info .button-section {
  float: none;
  padding-bottom: 30px;
}
.ctn-info .accordion {
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 30px;
}
.ctn-info .accordion .acc-content {
  padding-bottom: 20px;
}
.ctn-info .accordion .toggle-header {
  padding-top: 20px;
}
.ctn-info .accheader {
  font-family: "Omnes-ATT-W02";
}
.ctn-info .grid-table {
  margin-bottom: 30px;
}
.ctn-info .grid-table .odd {
  background-color: hsl(0, 0%, 95%);
}
.ctn-info .btn-default {
  background: linear-gradient(to bottom, #fcfcfc 0%, hsl(0, 0%, 95%) 100%);
}
.ctn-info .legend-container ul li {
  font-size: 14px !important;
}
.ctn-info thead th,
.ctn-info thead td,
.ctn-info tr th,
.ctn-info tr td {
  border-bottom: 1px solid #d2d2d2 !important;
  border-left: 1px solid #d2d2d2;
}
.ctn-info thead th:first-child,
.ctn-info thead td:first-child,
.ctn-info tr th:first-child,
.ctn-info tr td:first-child {
  border-left: 0;
}
.ctn-info thead th {
  border-left: 0;
}
@media (max-width: 1024px) {
  .ctn-info {
    margin: 0 15px;
    margin-top: 70px;
  }
  .ctn-info .add-scroll {
    overflow-y: scroll !important;
  }
  .ctn-info .add-scroll::-webkit-scrollbar {
    height: 0;
    width: 0;
  }
  .ctn-info h1 {
    margin-top: 20px;
  }
  .ctn-info .alert {
    margin: -10px -20px 20px;
  }
  .ctn-info .alert div:nth-child(2) {
    padding-right: 30px;
  }
  .ctn-info .nav-container {
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    display: block;
    position: relative;
    width: 100%;
  }
  .ctn-info .ctn-nav-icons, .ctn-info .ctn-nav-icons-oem {
    margin: 0;
  }
  .ctn-info .ctn-nav-icons li, .ctn-info .ctn-nav-icons-oem li {
    vertical-align: top;
    width: 49%;
  }
  .ctn-info .button-section {
    padding-top: 0;
    text-align: center;
  }
  .ctn-info .grid-table {
    margin-bottom: 20px;
    margin-left: 0;
  }
  .ctn-info tr th:first-child,
  .ctn-info tr td:first-child,
  .ctn-info thead th:first-child,
  .ctn-info thead td:first-child {
    padding: 10px 0;
    width: 30%;
  }
}

.lic-contest {
  background-color: #cccccc;
  padding: 20px 0;
}
@media (max-width: 1024px) {
  .lic-contest abbr,
  .lic-contest label {
    display: block;
    margin: 0;
  }
}
.lic-contest .lic-container > div {
  margin-bottom: 10px;
}

.model-box p {
  margin-top: 10px;
}
.model-box ol {
  margin: 12px 0 10px 20px;
}
.model-box ol li {
  list-style: decimal;
  line-height: 20px;
  margin-top: 12px;
  padding-left: 15px;
  position: relative;
  text-align: left;
}
.model-box ul {
  margin: 12px 0 10px 20px;
}
.model-box ul li {
  line-height: 20px;
  margin-top: 12px;
  padding-left: 15px;
  position: relative;
  text-align: left;
}
.model-box ul li::after {
  background-color: #333333;
  border: 2px solid #333333;
  border-radius: 100%;
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  top: 8px;
  width: 1px;
}
.model-box .tab-content {
  left: 0;
  padding: 0 15px;
}

.disabled {
  color: gray;
  cursor: not-allowed;
}

.img-disabled {
  cursor: not-allowed;
}

.message-modal .modal-body {
  height: 200px !important;
  padding-bottom: 0;
}
@media only screen and (max-height: 450px) {
  .message-modal .modal-body {
    max-height: 30vh;
    overflow: auto;
  }
}
@media (max-width: 767px) {
  .message-modal .modal-body {
    overflow: hidden;
    max-height: 100%;
  }
}
.message-modal .modal-footer {
  position: sticky;
}
@media only screen and (max-height: 438px) {
  .message-modal .modal-footer {
    position: relative;
  }
}
.message-modal p {
  margin-bottom: 20px;
  font-weight: normal;
}
.message-modal .description {
  margin-bottom: 20px;
}
.message-modal .form-group {
  margin: 20px 0;
}
.message-modal .form-group textarea {
  width: 100%;
  height: 100px;
  margin: 3px 0;
  border-color: #d2d2d2;
}
.message-modal .row {
  margin: 0;
}
@media (max-width: 1024px) {
  .message-modal .modal-footer a {
    text-align: center;
  }
}

.groupName {
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-inventory/ctn-info/ctn-info.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,mBAAA;AAmJF;;AAhJA;EACE,gBAAA;AAmJF;AAjJE;EACE,gBAAA;AAmJJ;AAhJE;EACE,oBAAA;AAkJJ;AA/IE;EACE,iCAAA;EACA,oBAAA;EACA,SAAA;AAiJJ;AA7II;EACE,eAAA;AA+IN;AA7II;EACE,qBAAA;AA+IN;AA3IE;EACE,gBAAA;EACA,oCAAA;EACA,cAAA;AA6IJ;AA3IA;EACE,gCAAA;AA6IF;AA3IA;EACE,6BAAA;AA6IF;AA3IE;EACE,gBAAA;AA6IJ;AA3II;EACE,oBAAA;AA6IN;AA1II;EACE,mBAAA;AA4IN;AAxIE;EACE,eAAA;AA0IJ;AAtII;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAwIN;AAtIM;EACE,eAAA;AAwIR;AArII;EACE,mBAAA;AAuIN;AAlII;EACE,mBAAA;EACA,wBAAA;AAoIN;AA/HI;EACE,mBAAA;EACA,qBAAA;AAiIN;AA7HE;EACE,WAAA;EACA,oBAAA;AA+HJ;AA5HE;EACE,gCAAA;EACA,mBAAA;AA8HJ;AA5HI;EACE,oBAAA;AA8HN;AA3HI;EACE,iBAAA;AA6HN;AA1HE;EAEE,4BAAA;AA2HJ;AAzHE;EACE,mBAAA;AA2HJ;AAzHI;EACE,iCAAA;AA2HN;AAvHE;EACE,wEAAA;AAyHJ;AArHM;EACE,0BAAA;AAuHR;AAhHI;;;;EAEE,2CAAA;EACA,8BAAA;AAoHN;AAlHM;;;;EACE,cAAA;AAuHR;AAjHI;EACE,cAAA;AAmHN;AF5OI;EElBJ;IAgJI,cAAA;IACA,gBAAA;EAkHF;EAhHE;IACE,6BAAA;EAkHJ;EAhHI;IACE,SAAA;IACA,QAAA;EAkHN;EA7GE;IACE,gBAAA;EA+GJ;EA5GE;IACE,wBAAA;EA8GJ;EA3GM;IACE,mBAAA;EA6GR;EAxGE;IF7IA,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IE+IE,cAAA;IACA,kBAAA;IACA,WAAA;EA8GJ;EA3GE;IACE,SAAA;EA6GJ;EA3GI;IACE,mBAAA;IACA,UAAA;EA6GN;EAzGE;IACE,cAAA;IACA,kBAAA;EA2GJ;EAxGE;IACE,mBAAA;IACA,cAAA;EA0GJ;EAnGM;;;;IACE,eAAA;IACA,UAAA;EAwGR;AACF;;AAjGA;EASE,yBAAA;EACA,eAAA;AA4FF;AFvSI;EEmMA;;IAEE,cAAA;IACA,SAAA;EAuGJ;AACF;AAjGE;EACE,mBAAA;AAmGJ;;AA/FE;EACE,gBAAA;AAkGJ;AAhGE;EACM,wBAAA;AAkGR;AAjGS;EACL,mBAAA;EACC,iBAAA;EACW,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAmGhB;AAhGE;EACU,wBAAA;AAkGZ;AAhGY;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAkGhB;AA/FY;EACI,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAiGhB;AA9FE;EACG,OAAA;EACG,eAAA;AAgGR;;AA3FA;EACE,WAAA;EACA,mBAAA;AA8FF;;AA3FA;EACE,mBAAA;AA8FF;;AA1FI;EACI,wBAAA;EACA,iBAAA;AA6FR;AA5FQ;EAHJ;IAIQ,gBAAA;IACA,cAAA;EA+FV;AACF;AA9FQ;EAPJ;IAQQ,gBAAA;IACA,gBAAA;EAiGV;AACF;AA/FI;EACI,gBAAA;AAiGR;AAhGQ;EAFJ;IAGM,kBAAA;EAmGR;AACF;AAhGI;EACI,mBAAA;EACA,mBAAA;AAkGR;AA/FI;EACI,mBAAA;AAiGR;AA/FI;EACE,cAAA;AAiGN;AA/FQ;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;AAiGV;AA7FI;EACI,SAAA;AA+FR;AF/YI;EEqTQ;IACI,kBAAA;EA6Fd;AACF;;AAxFA;EACE,qBAAA;AA2FF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.ctn-info-page {\n  margin-bottom: 30px;\n}\n\n.ctn-info {\n  margin: 0 16.66%;\n\n  h1 {\n    margin-top: 30px;\n  }\n\n  .alert {\n    margin: -10px 0 30px;\n  }\n\n  h2 {\n    font: 20px 'Omnes-ATT-W02-Medium';\n    padding: 30px 0 30px;\n    margin: 0;\n  }\n\n  .valign-children-middle {\n    h2 {\n      font-size: 16px;\n    }\n    h2, p {\n      padding: 0 !important;\n    }\n  }\n\n  .lite {\n    margin-top: 10px;\n    background-color: color(default, dark) !important;\n    color: color(default, dark);\n  }\n.userInfoContainer {\n  border-bottom :  1px solid color(default,dark);\n}\n.deviceInfoContainer {\n  border-top :  1px solid color(default,dark);\n}\n  p {\n    margin-bottom: 0;\n\n    &:last-child {\n      padding-bottom: 30px;\n    }\n\n    span {\n      font-weight: normal;\n    }\n  }\n\n  .nav-container {\n    display: inline;\n  }\n\n  .ctn-nav-icons, .ctn-nav-icons-oem {\n    li {\n      display: inline-block;\n      margin: 20px 0 20px;\n      text-align: center;\n      vertical-align: top;\n      width: 24%;\n\n      i {\n        font-size: 50px;\n      }\n    }\n    img {\n      margin-bottom: 10px;\n    }\n  }\n\n  .lock-support-modal {\n    li {\n      font-weight: normal;\n      list-style-type: decimal;\n    }\n  }\n\n  .wipe-support-modal {\n    li {\n      font-weight: normal;\n      list-style-type: disc;\n    }\n  }\n\n  .button-section {\n    float: none;\n    padding-bottom: 30px;\n  }\n\n  .accordion {\n    border-bottom: 1px solid color(default, dark);\n    margin-bottom: 30px;\n\n    .acc-content {\n      padding-bottom: 20px;\n    }\n\n    .toggle-header {\n      padding-top: 20px;\n    }\n  }\n  .accheader{\n    // color : #191919;\n    font-family: 'Omnes-ATT-W02';\n  }\n  .grid-table {\n    margin-bottom: 30px;\n\n    .odd {\n      background-color: color(default, base);\n    }\n  }\n\n  .btn-default {\n    background: linear-gradient(to bottom, #fcfcfc 0%, color(default,base) 100%);\n  }\n  .legend-container {\n    ul {\n      li {\n        font-size: 14px !important; //to over ride child component SCSS\n      }\n    }\n  }\n\n  thead,\n  tr {\n    th,\n    td {\n      border-bottom: 1px solid color(default, dark) !important; //to over ride child component SCSS\n      border-left: 1px solid color(default, dark);\n\n      &:first-child {\n        border-left: 0;\n      }\n    }\n  }\n\n  thead {\n    th {\n      border-left: 0;\n    }\n  }\n\n  @include respond-to(small) {\n    margin: 0 15px;\n    margin-top: 70px;\n\n    .add-scroll {\n      overflow-y: scroll !important;\n      \n      &::-webkit-scrollbar {\n        height: 0;\n        width: 0;\n      }\n\n    }\n\n    h1 {\n      margin-top: 20px;\n    }\n\n    .alert {\n      margin: -10px -20px 20px;\n\n      div {\n        &:nth-child(2) {\n          padding-right: 30px;\n        }\n      }\n    }\n\n    .nav-container {\n      @include vendor-prefix('transform', none);\n      display: block;\n      position: relative;\n      width: 100%;\n    }\n\n    .ctn-nav-icons, .ctn-nav-icons-oem {\n      margin: 0;\n\n      li {\n        vertical-align: top;\n        width: 49%;\n      }\n    }\n\n    .button-section {\n      padding-top: 0;\n      text-align: center;\n    }\n\n    .grid-table {\n      margin-bottom: 20px;\n      margin-left: 0;\n    }\n\n    tr,\n    thead {\n      th,\n      td {\n        &:first-child {\n          padding: 10px 0;\n          width: 30%;\n        }\n      }\n    }\n\n  }\n}\n\n.lic-contest {\n  @include respond-to (small) {\n    abbr,\n    label {\n      display: block;\n      margin: 0;\n    }\n  }\n\n  background-color: color(outOfCompliance);\n  padding: 20px 0;\n\n  .lic-container > div {\n    margin-bottom: 10px;\n  }\n}\n.model-box{\n  p{\n    margin-top: 10px;\n  }\n  ol{\n        margin: 12px 0 10px 20px;\n         li {\n    list-style: decimal;\n     line-height: 20px;\n                margin-top: 12px;\n                padding-left: 15px;\n                position: relative;\n                text-align: left;\n  }\n  }\n  ul{\n            margin: 12px 0 10px 20px;\n\n            li {\n                line-height: 20px;\n                margin-top: 12px;\n                padding-left: 15px;\n                position: relative;\n                text-align: left;\n            }\n\n            li::after{\n                background-color: #333333;\n                border: 2px solid #333333;\n                border-radius: 100%;\n                content: '';\n                display: block;\n                height: 1px;\n                left: 0;\n                position: absolute;\n                top: 8px;\n                width: 1px;\n            }\n        }\n  .tab-content{\n     left: 0;\n        padding:0 15px;\n\n  }\n}\n\n.disabled {\n  color: gray;\n  cursor: not-allowed;\n}\n\n.img-disabled {\n  cursor: not-allowed;\n}\n\n.message-modal {\n    .modal-body {\n        height: 200px !important;\n        padding-bottom: 0;\n        @media only screen and (max-height: 450px) {\n            max-height: 30vh;\n            overflow: auto;\n        }\n        @media (max-width: 767px) {\n            overflow: hidden;\n            max-height: 100%;\n        }\n    }\n    .modal-footer {\n        position: sticky;\n        @media only screen and (max-height: 438px) {\n          position: relative;\n        }\n      }\n\n    p {\n        margin-bottom: 20px;\n        font-weight: normal;\n    }\n\n    .description{\n        margin-bottom: 20px;\n    }\n    .form-group {\n      margin: 20px 0;\n\n        textarea {\n          width: 100%;\n          height: 100px;\n          margin: 3px 0;\n          border-color: color(default, dark);\n        }\n    }\n\n    .row {\n        margin: 0;\n    }\n    \n    @include respond-to(small) {\n        .modal-footer {\n            a {\n                text-align: center;\n            }\n        }\n    }\n}\n\n.groupName{\n  word-break: break-all;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
